import React from 'react';

import { useCheckSuppliersCount } from '@/modules/workforce/Contracts/apiHooks';
import { ContractsTable } from '@/modules/workforce/Contracts/components/Main/ContractsTable';
import { FiltersTabs } from '@/modules/workforce/Contracts/components/Main/FiltersTabs';
import { Header } from '@/modules/workforce/Contracts/components/Main/Header';
import { ContractsProvider } from '@/modules/workforce/Contracts/context';

export default function Contracts() {
  const { data } = useCheckSuppliersCount();

  return (
    <ContractsProvider>
      <div className='flex flex-col gap-24'>
        <Header suppliersCount={data?.totalCount} />
        <FiltersTabs />
        <ContractsTable suppliersCount={data?.totalCount} />
      </div>
    </ContractsProvider>
  );
}
